module.exports = __webpack_public_path__ + "img/pic-a-5.png";